import Footer from '../../components/footer/footer';
import ShopNav from '../../components/shopNav/ShopNav';
import NavCategorias from '../../components/navbar/NavCategorias';
import CategoriasDestacadas from '../../components/shop/CategoriasDestacadas';
import ProductosDestacados from '../../components/shop/ProductosDestacados';
import Marcasdestacadas from '../../components/shop/MarcasDestacadas';
import RandomCategoryProducts from '../../components/shop/RandomCategoryProducts';
import { Carousel, Container, Row, Col } from 'react-bootstrap';
import './shop.css';
import ServiceHighlights from '../../components/servicehighlights/ServiceHighlights';

function Shop() {
  return (
    <div className="shop">
      <ShopNav />
      <NavCategorias />
      <main className="shop-main">
        {/* Hero Section with Carousel */}
        <section className="shop-carousel">
          <Carousel fade interval={6000} className="mb-0">
            <Carousel.Item>
              <video className="d-block w-100" autoPlay loop muted playsInline>
                <source src="/videos/video1.mp4" type="video/mp4" />
                Tu navegador no soporta el video.
              </video>
              <Carousel.Caption>
                <h3>Bienvenido a Vintage Pro Audio</h3>
                <p>Explora equipos profesionales de sonido para tus proyectos.</p>
              </Carousel.Caption>
            </Carousel.Item>

            <Carousel.Item>
              <video className="d-block w-100" autoPlay loop muted playsInline>
                <source src="/videos/video2.mp4" type="video/mp4" />
                Tu navegador no soporta el video.
              </video>
              <Carousel.Caption>
                <h3>Explora el Sonido Profesional</h3>
                <p>Calidad visual y auditiva para tu estudio o escenario.</p>
              </Carousel.Caption>
            </Carousel.Item>

            <Carousel.Item>
              <video className="d-block w-100" autoPlay loop muted playsInline>
                <source src="/videos/cone.mp4" type="video/mp4" />
                Tu navegador no soporta el video.
              </video>
              <Carousel.Caption>
                <h3>Explora el Sonido Profesional</h3>
                <p>Calidad visual y auditiva para tu estudio o escenario.</p>
              </Carousel.Caption>
            </Carousel.Item>

            <Carousel.Item>
              <img className="d-block w-100" src="/images/banner1.jpg" alt="Promo 1" />
              <Carousel.Caption>
                <h3>Bienvenido a Vintage Pro Audio</h3>
                <p>Explora equipos profesionales de sonido para tus proyectos.</p>
              </Carousel.Caption>
            </Carousel.Item>

            <Carousel.Item>
              <img className="d-block w-100" src="/images/focus1.jpg" alt="Promo 2" />
              <Carousel.Caption>
                <h3>Descuentos exclusivos</h3>
                <p>Hasta 30% en productos seleccionados.</p>
              </Carousel.Caption>
            </Carousel.Item>
          </Carousel>
        </section>

        {/* Header de la tienda */}
        <section className="shop-header py-3 shop-elevated-wrap shop-elevated-wrap--hero">
          <div className="container">
            <div className="row">
              <div className="col-lg-10 mx-auto">
                <div className="shop-header-content animate__animated animate__fadeIn">
                  <div className="shop-header-text">
                    <h1 className="display-4 animate__animated animate__fadeIn">Tu Próximo Sonido Empieza Aquí</h1>
                    <p className="lead mb-4 animate__animated animate__fadeIn">
                      Seleccionamos equipos pro para estudio, escenario y producción: audio con carácter Vintage Pro Audio.
                    </p>
                  </div>
                  <div className="shop-header-logo-wrap animate__animated animate__fadeIn" aria-hidden="true">
                    <img src="/images/VPA.png" alt="Vintage Pro Audio" className="shop-header-logo" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="shop-elevated-wrap">
          <ServiceHighlights />
        </section>
        {/* Marcas destacadas */}

        {/* Productos destacados */}
        <section className="py-3 shop-elevated-wrap">
          <ProductosDestacados />
        </section>

        <section className="py-3 shop-elevated-wrap">
          <Marcasdestacadas />
        </section>

        {/* Productos destacados */}
        <section className="py-3 shop-elevated-wrap">
          <ProductosDestacados />
        </section>

        {/* Categorías destacadas */}
        <section className="py-3 shop-elevated-wrap">
          <CategoriasDestacadas />
        </section>

        {/* Grid aleatorio por categorías destacadas */}
        <section className="py-3 shop-elevated-wrap">
          <RandomCategoryProducts />
        </section>

        {/* Beneficios */}
        <section className="benefits-section">
          <Container className="benefits-container">
            <Row className="text-center benefits-grid">
              <Col md={4} className="benefits-col">
                <div className="benefits-item">
                <i className="bi bi-truck fs-1 benefits-icon"></i>
                <h5 className="mt-2 benefits-title">Envíos Nacionales</h5>
                <p>Recibe tu equipo en cualquier parte de Colombia.</p>
                </div>
              </Col>
              <Col md={4} className="benefits-col">
                <div className="benefits-item">
                <i className="bi bi-shield-lock fs-1 benefits-icon"></i>
                <h5 className="mt-2 benefits-title">Pagos Seguros</h5>
                <p>Usamos plataformas confiables para garantizar tu seguridad.</p>
                </div>
              </Col>
              <Col md={4} className="benefits-col">
                <div className="benefits-item">
                <i className="bi bi-headset fs-1 benefits-icon"></i>
                <h5 className="mt-2 benefits-title">Soporte Técnico</h5>
                <p>Asesoría personalizada para tus compras.</p>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default Shop;
